import classNames from 'clsx'
import { node, string } from 'prop-types'

const ProductVariantHeaderColumn = ({ children, className, id }) => {
  const columnClassNames = classNames(
    'o-ProductVariants__ProductVariantsHeader__column',
    className
  )

  return (
    <li id={id} className={columnClassNames}>
      {children}
    </li>
  )
}

ProductVariantHeaderColumn.propTypes = {
  children: node,
  className: string,
  id: string,
}

ProductVariantHeaderColumn.defaultProps = {
  children: null,
  className: '',
  id: '',
}

export default ProductVariantHeaderColumn
